export enum HttpEndpoints {
  LOGIN = '/api/client/login',
  REGISTRATION = '/api/client/registration',
  USER = '/api/client/profile/me',

  UPLOAD_IMAGE = '/api/client/images',

  GET_PWA_LIST = '/api/client/pwas',
  CREATE_PWA_ITEM = '/api/client/pwas',
  GET_PWA_ITEM = '/api/client/pwas/{id}',
  DELETE_PWA_ITEM = '/api/client/pwas/{id}',
  CLONE_PWA_ITEM = '/api/client/pwas/{id}/clone',
  ACTIVATE_PWA_ITEM = '/api/client/pwas/{id}/activate',
  DEACTIVATE_PWA_ITEM = '/api/client/pwas/{id}/deactivate',
  SAVE_PWA_ITEM = '/api/client/pwas/{id}',
  TRANSLATE_PWA_CONTENT = '/api/client/pwas/{id}/translate',

  DESIGN = '/api/client/pwa/design/preset',

  GET_DOMAINS = '/api/client/pwa/web_domains',
  ACQUIRE_DOMAIN = '/api/client/pwa/web_domains/acquire',

  PWA = '/pwa',

  GET_FACEBOOK_PIXELS_LIST = '/api/client/pwa/fb_pixels',
  CREATE_FACEBOOK_PIXEL = '/api/client/pwa/fb_pixels',
  UPDATE_FACEBOOK_PIXEL = '/api/client/pwa/fb_pixels/{id}',
  DELETE_FACEBOOK_PIXEL = '/api/client/pwa/fb_pixels/{id}',

  GET_FACEBOOK_TOKEN_DATA = 'https://graph.facebook.com/debug_token',

  GET_OFFER_LIST = '/api/client/offer_urls',
  CREATE_OFFER = '/api/client/offer_urls',
  GET_OFFER = '/api/client/offer_urls/{id}',
  UPDATE_OFFER = '/api/client/offer_urls/{id}',
  DELETE_OFFER = '/api/client/offer_urls/{id}',

  INVITE_LIST = '/api/client/invites',
  CREATE_INVITE = '/api/client/invites',
  SAVE_INVITE = '/api/client/invites',
  DELETE_INVITE = '/api/client/invites/{id}',

  AFFILIATE_LIST = '/api/client/affiliates',
  SAVE_AFFILIATE = '/api/client/affiliate/{id}',
  AFFILIATE_TRANSFER_BALANCE = '/api/client/affiliate/{id}/balance/transfer',
  GET_TRANSACTIONS_BY_AFFILIATE = '/api/client/transactions/{id}',
  GET_MY_TRANSACTIONS = '/api/client/transactions/me',

  GET_STATISTICS = '/api/client/pwa/analytics',

  CLIENT_POSTBACKS = '/api/client/pwa/client_postbacks',

  UPLOAD_PUSH_FILE = '/api/client/pwas/push_notification/import',
}
